import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IPlatformSubscriptionPlanVm } from '../platform-subscription-plan-vm.model';
@Injectable({ providedIn: 'root' })
export class PlatformAvailableSubscriptionPlansForOskService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/PlatformAvailableSubscriptionPlansForOsk`;
  }
  get(acceptLanguage: string): Observable<IPlatformSubscriptionPlanVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      params = params.set('acceptLanguage', acceptLanguage.toString());
    }
    return this.http.get<IPlatformSubscriptionPlanVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
